export default __webpack_public_path__ + "static/media/school-large.fb3b4daa.png";